import React from 'react';
import PropTypes from 'prop-types';

import ShoppingCartContent from '@Components/Results/structure/availability/ShoppingCartContent';
import { shoppingCartStatusCheck } from '@Components/Results/structure/availability/ShoppingCartHelper';

// TODO RXFE-6466 for React
export default class ShoppingCartComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      status: false,
    };

    this._pendingCheckStatus = null;
  }

  componentDidMount() {
    const { availability, structure, allowCommercialDBOnly } = this.props;
    this._pendingCheckStatus = shoppingCartStatusCheck({ availability, structure, allowCommercialDBOnly })
      .then((status) => {
        // eslint-disable-next-line no-unused-expressions
        this._pendingCheckStatus && this.setState({ status });
        this._pendingCheckStatus = null;
      })
      .catch(Logger.error);
  }

  componentWillUnmount() {
    this._pendingCheckStatus = null;
  }

  render() {
    // eslint-disable-next-line react/destructuring-assignment
    if (!this.state.status) {
      return null;
    }
    return <ShoppingCartContent {...this.props} />;
  }
}

ShoppingCartComponent.defaultProps = {
  onOpen: () => null,
  onOptionClick: () => null,
};

ShoppingCartComponent.propTypes = {
  availability: PropTypes.object.isRequired,
  structure: PropTypes.object.isRequired,
  trackingContext: PropTypes.string,
  onOpen: PropTypes.func,
  onOptionClick: PropTypes.func,
  tooltipId: PropTypes.string,
  allowCommercialDBOnly: PropTypes.bool,
  trackingContent: PropTypes.array,
};
